import React from "react";
import SvgIconDPC from "./dpc-svg-icon";

export default class DpcAreeTematiche extends React.Component {

    getAreeTematiche = (elements, arrayMappeDomande) => {
        
        const originalArray = elements;
        let newArray = [...originalArray];
        
        //Sposto i minisiti mappe e domande in un nuovo array, che utilizzerò per creare i rispettivi bottoni blu
        /*for(let i = 0; i <= newArray.length -1 ; i++){
            let item = elements[i];
            console.log(item);
            if((item.name === ("Mappe") || item.name === ("Maps")) || (item.name === ("Domande e risposte") || item.name === ("FAQ"))){              
                newArray.splice(newArray.indexOf(item), 1);
                arrayMappeDomande.push(item);
            }
        }*/
        var i = 0;
        while (i < newArray.length) {
            let item = newArray[i];
            if ((item.name === ("Mappe") || item.name === ("Maps")) || (item.name === ("Domande e risposte") || item.name === ("FAQ"))) {
                newArray.splice(i, 1);
                arrayMappeDomande.push(item);
            } else {
            ++i;
            }
        }
        //trasformo l'array in una matrice
        newArray = this.chunk(newArray, Math.min(4, newArray.length));

        return newArray
    };

    chunk = (arr, size) => arr.reduce((acc, e, i) => (i % size ? acc[acc.length - 1].push(e) : acc.push([e]), acc), []);

    checkClassIcon = (item) => {
        return ['Mappe', 'Maps', 'Domande e risposte', 'FAQ'].includes(item) ? ' btn-icon' : '';
    }

    render(){
        var arrayMappeDomande = [];
        if(Array.isArray(this.props.elements))
            return (
                <section className="container btn-block-uppercase-wrapper">
                    <h3>{this.props.title}</h3>
                    <div className="px-custom">
                        {
                            //newArray = this.removeMappeDomande(this.props.elements),
                            this.getAreeTematiche(this.props.elements, arrayMappeDomande).map(row =>
                                <div className="row">
                                    {Array.isArray(row) &&
                                    row.sort((a, b) => a.weight > b.weight ? 1 : -1).map(button =>
                                        <div className="col-12 col-sm-6 col-md">
                                            <a href={button.field_url_path} className={"btn btn-area-tema"}
                                               title={button.name}
                                               role="button">
                                                {button.name}
                                            </a>
                                        </div>
                                    )
                                    }
                                </div>
                            )
                        }
                        <div className="row">
                            {
                                Array.isArray(arrayMappeDomande) &&
                                arrayMappeDomande.map(button =>
                                    <div className="col-12 col-sm-6 col-md">
                                        <a href={button.field_url_path} className={"btn btn-area-tema" + this.checkClassIcon(button.name)}
                                           title={button.name}
                                           role="button">
                                            {(button.name === 'Mappe' || button.name === 'Maps') ? <SvgIconDPC name={"map-marker-circle"}
                                                                                            classiAggiuntive={"icon-sm"} color={'#003569'}/> : null}
                                            {(button.name === ("Domande e risposte") || button.name === ("FAQ")) ? <SvgIconDPC name={"help-circle"}
                                                                                                               classiAggiuntive={"icon-sm"} color={'#003569'}/> : null}
                                            <span>{button.name}</span>
                                        </a>
                                    </div>
                                )
                            }
                        </div>
                    </div>
                </section>
            );
        return ("");
    }

}
